import React, { useState, useEffect } from 'react';

import './styles.css';

import Card from '../../../../components/Card';
import ActivityIndicator from '../../../../components/ActivityIndicator';
import Notice from '../../../../components/Notice';
import { FaArrowUp, FaArrowDown, FaFileInvoiceDollar, FaHistory, FaRegClock, FaFilter, FaPrint, FaTrash } from 'react-icons/fa';
import reportServices from '../../../../services/reportServices';
import PopupReports from '../../../../components/PopupReports';
import bankAccountsTransferServices from '../../../../services/admFin/bankAccountTransferServices';
import BankAccountTransferCardItem from './BankAccountTransferCardItem';
import bankAccountTransferServices from '../../../../services/admFin/bankAccountTransferServices';
import BankAccountTransferPopUp from './BankAccountTransferPopUp';
import FilterBankAccountTransfersPopUp from './FilterBankAccountTransfersPopUp';
import Popup from '../../../../components/Popup';

export default function BankAccountTransfersCard(props) {
    const [bankAccountsTransfers, setBankAccountsTransfers] = useState([]);
    const [bankAccountsTransfersToShow, setBankAccountsTransfersToShow] = useState([]);
    const [visibilityNewTransfer, setVisibilityNewTransfer] = useState(false);
    const [fetching, setFetching] = useState(false);


    const [visibilityFilter, setVisibilityFilter] = useState(false);
    const [visibilityReport, setVisibilityReport] = useState(false);

    useEffect(() => {
        getBankAccountsTransfers();
    }, []);
    useEffect(() => {
        if(bankAccountsTransfers.length)
            setBankAccountsTransfersToShow(bankAccountsTransfers)
    }, [bankAccountsTransfers])

    async function getBankAccountsTransfers() {
        setFetching(true);
        try {
            const response = await bankAccountTransferServices.getBankAccountsTransfers();
            setBankAccountsTransfers(response.data);
        } catch (err) {
            alert(err.message);
        }
        setFetching(false);
    }

    function generateReport(fields = null, fileName) {
        console.log(fields);
        try {
            reportServices.generateReportBankAccoutTransfers(bankAccountsTransfersToShow, `RELATÓRIO DE TRANSFERÊNCIAS BANCÁRIAS`, fields, fileName);
            return true;
        } catch (err) {
            alert(err.message);
            return false;
        }
    }

    async function deleteBankAccountTransfer(id) {
        // eslint-disable-next-line no-restricted-globals
        if(confirm("Deseja deletar esta transferência?")) {
            try {
                await bankAccountsTransferServices.deleteBankAccountTransfer(id);

                setBankAccountsTransfers(oldArray => {
                    const temp = [...oldArray];
                    return temp.filter(obj => obj.id !== id);
                })
            } catch(err) {
                alert("Erro ao deletar transferência");
            }
        }
    }

    return (
        <Popup
            id={`bank-account-transfers-card`}
            className={"bills-card"}
            tittle="Transferências Bancárias"
            icon={<FaHistory />}
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            //subtittle={props.cardSubtittle ? props.cardSubtittle : selectSubtittle()}
                
        >
            <div className='pop-up-bank-account-transfer-options'>
                <div>
    
                    <button type='button' onClick={() => setVisibilityFilter(true)}>
                        <FaFilter />
                    </button>
                    <FilterBankAccountTransfersPopUp
                        visibility={visibilityFilter}
                        setVisibility={setVisibilityFilter}
                        bankAccountTransfers={bankAccountsTransfers}
                        setBankAccountTransfers={setBankAccountsTransfersToShow}
                    />


                    <button title="Gerar relatório" onClick={() => setVisibilityReport(true)}><FaPrint /></button>
                    <PopupReports
                        visibility={visibilityReport}
                        setVisibility={setVisibilityReport}
                        tittle="Relatório de Transferências Bancárias"
                        fields={reportServices.bankAccountTransferFields}
                        generateReport={generateReport}
                    />

                </div>
                <button
                    onClick={() => setVisibilityNewTransfer(true)}
                >
                    Realizar Transferência
                </button>
                <BankAccountTransferPopUp
                visibility={visibilityNewTransfer}
                setVisibility={setVisibilityNewTransfer}
                setBankAccountTransfers={setBankAccountsTransfers}
                bankAccounts={props.bankAccounts}
                getBankAccounts={props.getBankAccounts}
                />

            </div>
            
            

            {
                bankAccountsTransfers.length ?
                    bankAccountsTransfersToShow.length ?
                        <ul className='list'>
                            {
                                bankAccountsTransfersToShow.map((item, index) =>
                                <div className='bill-item-container'>
                                    <div>

                                        <BankAccountTransferCardItem
                                            key={item.id}
                                            descricao={item.descricao}
                                            conta_origem={item.conta_origem}
                                            conta_destino={item.conta_destino}
                                            valor={item.valor}
                                            data={item.data}
                                            code={item.id}
                                        />
                                    </div>
                                    <button className="red" onClick={() => deleteBankAccountTransfer(item.id)}>
                                        <FaTrash />
                                    </button>
                                </div>
                                )
                            }
                        </ul>
                        : (
                            <Notice>Não há transferências a serem listadas</Notice>
                        )
                    : (
                        fetching ?
                        <ActivityIndicator />
                        :
                        null
                    )
            }
        </Popup>
    )
}